export default "__VITE_ASSET__38f593bd__"